<template>
  <div class="lottery">
    <div class="height-div">
      <!-- content home -->
      <section class="hero hero-center wysiwyg">
        <a
          href="#"
          class="arrow-down"
          v-in-viewport="{}"
          v-scroll-to="'#section'"
        ></a>
        <div class="hero-image-mask">
          <div class="hero-title-container">
            <div class="container-fluid fullwidth">
              <div class="inside">
                <div
                  class="headline-wysiwyg in-viewport fully-in-viewport"
                  data-in-viewport="i5"
                >
                  <div class="line" id="line1">
                    <div id="phrase1"><h2>Let’s</h2></div>
                    <div id="phrase2"><h2>be</h2></div>
                    <div id="phrase3"><h2>real.</h2></div>
                  </div>

                  <div class="line" id="line2">
                    <h2>When people think about lotteries,</h2>
                  </div>

                  <div class="line" id="line3">
                    <h2>they think about getting a big check.</h2>
                  </div>

                  <div class="line" id="line4">
                    <h2>
                      They don’t think about you and your team.<strong
                        id="statement"
                        >We do.</strong
                      >
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="overlay-gradient"></div>
          <div
            class="hero-image hidden-xs"
            style="background-image: white"
          ></div>
          <div
            class="hero-image hidden-sm"
            style="background-image: white"
          ></div>
        </div>
        <!---->
      </section>
      <!-- END HERO -->

      <section id="section" class="main-content blue">
        <div class="wrapper">
          <div class="inside">
            <div class="description">
              <p class="main-title">Our Purpose</p>
              <h2>We’re here to make you a winner</h2>
              <p>
                Players win when they play. But for you, winning isn’t fun and
                games. It’s about improving your lottery’s performance.
                Optimizing the value exchange with your players (and retailers).
                And since lottery technologies, games and players' needs change
                over time, you need solutions that leverage player data and UX
                to adapt to those changes. That’s what we do. We help you
                continuously improve player experiences and engagement – and
                squeeze more from your marketing and advertising investments.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- Technologies Cases -->
    <section class="content-section tech-cases" v-in-viewport="">
      <div class="container-fluid">
        <div class="inside row">
          <div class="tech-box">
            <span class="sub">AdaptEP™</span>
            <h2>First party data is marketing fuel</h2>
            <p>
              AdaptEP™ is an intelligent marketing ecosystem specifically for
              lotteries. Manage your mobile app, website, loyalty and rewards,
              all from one platform. Collect player data from all touchpoints
              and game sources. And use it all to supercharge your marketing.
              You've never seen anything like this.
            </p>
            <a href="https://player.vimeo.com/progressive_redirect/playback/711700117/rendition/1080p/file.mp4?loc=external&signature=e79bca5a43224c2a4c4bcc4840bc7a12b037a67273fcb1d0053e98dfeee4fe9e" target="_blank" class="btn_orange">WATCH THE VIDEO</a>
          </div>

          <div class="tech-box">
            <span class="sub">Mobile Cashing</span>
            <h2>True cashless payment in a mobile app</h2>
            <p>
              A lottery industry first, Marcus Thomas’ cashless payout system
              delivers secure, mobile-only payouts right from a mobile app. The
              player scans an eligible ticket, selects CASH OUT and initiates
              the process of ID and ticket verification, state debt withholding,
              and depositing their winnings directly into their bank account. A
              win for players. A win for retailers. And a win for your lottery.
            </p>
          </div>

          <div class="tech-box">
            <span class="sub">Retailer Acquisition and Management</span>
            <h2>Retailer onboarding in days, not months</h2>
            <p>
              Let’s be blunt: While prospective retailers are filling out forms,
              they’re not generating sales. We fixed that with an online process
              that takes the retailer from interested to vetted to selling. Oh,
              and the solution can pay for itself in just a few months, too.
            </p>
          </div>

          <div class="tech-box">
            <span class="sub">Loyalty and Rewards</span>
            <h2>Turnkey loyalty and rewards – and management flexibility</h2>
            <p>
              Nearly 2 million players. More than 350 million non-transactions.
              And more than $15 million in prize payouts. All from a custom
              solution with responsive website and mobile app, digital and
              physical prize fulfillment, dynamic user/winner verifications, and
              mobile cashing. That’s Ohio Lottery’s MyLotto Rewards®.
            </p>
          </div>

          <div class="tech-box">
            <span class="sub">Hosting and Web Services</span>
            <h2>Challenging traffic transformed into revenue source</h2>
            <p>
              Big traffic is good, right? For Mega Millions, if left unmanaged,
              massive traffic spikes could be disastrous. Or – with some
              creative technology architecture – massively productive. We
              developed an efficient, scalable solution that replaced headaches
              with revenue, helping to support Mega Millions’ marketing efforts.
            </p>
          </div>

          <div class="tech-box">
            <span class="sub">Systems Consulting</span>
            <h2>COAM Win for Georgia Lottery</h2>
            <p>
              A lottery’s coin operated footprint is a complicated network of
              providers that requires timely and precise management of licenses
              and services. And time is money. Georgia Lottery called on us to
              handle dev operations for this complex challenge.
            </p>
          </div>
          <div class="svg-bg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1623px"
              height="3642px"
              viewBox="0 0 1623 3642"
              id="svgRoute"
            >
              <!-- BACKGROUND LINES START -->

              <g
                id="Lottery-Landing-Page"
                stroke="#EDEDED"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g id="Lottery-Landing-Page-desktop">
                  <g id="Group-479">
                    <path
                      d="M1386.0723,82.3053 C1386.0723,86.1273 1382.9743,89.2253 1379.1523,89.2253 C1375.3303,89.2253 1372.2323,86.1273 1372.2323,82.3053 C1372.2323,78.4833 1375.3303,75.3853 1379.1523,75.3853 C1382.9743,75.3853 1386.0723,78.4833 1386.0723,82.3053"
                      id="Fill-1"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1207.6268,188.3809 C1207.6268,192.2029 1204.5288,195.3009 1200.7068,195.3009 C1196.8848,195.3009 1193.7868,192.2029 1193.7868,188.3809 C1193.7868,184.5589 1196.8848,181.4609 1200.7068,181.4609 C1204.5288,181.4609 1207.6268,184.5589 1207.6268,188.3809"
                      id="Fill-3"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1096.9434,414.3516 C1096.9434,418.1736 1093.8454,421.2716 1090.0234,421.2716 C1086.2014,421.2716 1083.1034,418.1736 1083.1034,414.3516 C1083.1034,410.5296 1086.2014,407.4316 1090.0234,407.4316 C1093.8454,407.4316 1096.9434,410.5296 1096.9434,414.3516"
                      id="Fill-5"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1386.0723,293.2225 C1386.0723,297.0445 1382.9743,300.1425 1379.1523,300.1425 C1375.3303,300.1425 1372.2323,297.0445 1372.2323,293.2225 C1372.2323,289.4005 1375.3303,286.3025 1379.1523,286.3025 C1382.9743,286.3025 1386.0723,289.4005 1386.0723,293.2225"
                      id="Fill-7"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1179.2469,334.1637 C1179.2469,337.9857 1176.1489,341.0837 1172.3269,341.0837 C1168.5049,341.0837 1165.4069,337.9857 1165.4069,334.1637 C1165.4069,330.3417 1168.5049,327.2437 1172.3269,327.2437 C1176.1489,327.2437 1179.2469,330.3417 1179.2469,334.1637"
                      id="Fill-9"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1411.1124,371.5264 C1411.1124,375.3484 1408.0144,378.4464 1404.1924,378.4464 C1400.3704,378.4464 1397.2724,375.3484 1397.2724,371.5264 C1397.2724,367.7044 1400.3704,364.6064 1404.1924,364.6064 C1408.0144,364.6064 1411.1124,367.7044 1411.1124,371.5264"
                      id="Fill-11"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1477.6934,293.2225 C1477.6934,295.5615 1475.7974,297.4575 1473.4584,297.4575 C1471.1194,297.4575 1469.2224,295.5615 1469.2224,293.2225 C1469.2224,290.8835 1471.1194,288.9875 1473.4584,288.9875 C1475.7974,288.9875 1477.6934,290.8835 1477.6934,293.2225"
                      id="Fill-13"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1399.1995,117.8817 C1399.1995,120.2207 1397.3035,122.1167 1394.9645,122.1167 C1392.6255,122.1167 1390.7285,120.2207 1390.7285,117.8817 C1390.7285,115.5427 1392.6255,113.6467 1394.9645,113.6467 C1397.3035,113.6467 1399.1995,115.5427 1399.1995,117.8817"
                      id="Fill-15"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1210.588,385.8341 C1210.588,388.1731 1208.692,390.0691 1206.353,390.0691 C1204.014,390.0691 1202.117,388.1731 1202.117,385.8341 C1202.117,383.4951 1204.014,381.5991 1206.353,381.5991 C1208.692,381.5991 1210.588,383.4951 1210.588,385.8341"
                      id="Fill-17"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1308.8467,209.9285 C1308.8467,212.2675 1306.9507,214.1635 1304.6117,214.1635 C1302.2727,214.1635 1300.3757,212.2675 1300.3757,209.9285 C1300.3757,207.5895 1302.2727,205.6935 1304.6117,205.6935 C1306.9507,205.6935 1308.8467,207.5895 1308.8467,209.9285"
                      id="Fill-19"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1455.9523,225.7403 C1455.9523,228.0793 1454.0563,229.9753 1451.7173,229.9753 C1449.3783,229.9753 1447.4813,228.0793 1447.4813,225.7403 C1447.4813,223.4013 1449.3783,221.5053 1451.7173,221.5053 C1454.0563,221.5053 1455.9523,223.4013 1455.9523,225.7403"
                      id="Fill-21"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1304.6113,366.9166 C1304.6113,369.2556 1302.7153,371.1516 1300.3763,371.1516 C1298.0373,371.1516 1296.1403,369.2556 1296.1403,366.9166 C1296.1403,364.5776 1298.0373,362.6816 1300.3763,362.6816 C1302.7153,362.6816 1304.6113,364.5776 1304.6113,366.9166"
                      id="Fill-23"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1132.6588,179.7169 C1132.6588,182.0559 1130.7628,183.9519 1128.4238,183.9519 C1126.0848,183.9519 1124.1878,182.0559 1124.1878,179.7169 C1124.1878,177.3779 1126.0848,175.4819 1128.4238,175.4819 C1130.7628,175.4819 1132.6588,177.3779 1132.6588,179.7169"
                      id="Fill-25"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1183.4822,532.9398 C1183.4822,535.2788 1181.5862,537.1748 1179.2472,537.1748 C1176.9082,537.1748 1175.0112,535.2788 1175.0112,532.9398 C1175.0112,530.6008 1176.9082,528.7048 1179.2472,528.7048 C1181.5862,528.7048 1183.4822,530.6008 1183.4822,532.9398"
                      id="Fill-27"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1029.1788,504.7044 C1029.1788,508.5264 1026.0808,511.6244 1022.2588,511.6244 C1018.4368,511.6244 1015.3388,508.5264 1015.3388,504.7044 C1015.3388,500.8824 1018.4368,497.7844 1022.2588,497.7844 C1026.0808,497.7844 1029.1788,500.8824 1029.1788,504.7044"
                      id="Fill-29"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1531.6227,168.5618 C1531.6227,172.3838 1528.5247,175.4818 1524.7027,175.4818 C1520.8807,175.4818 1517.7827,172.3838 1517.7827,168.5618 C1517.7827,164.7398 1520.8807,161.6418 1524.7027,161.6418 C1528.5247,161.6418 1531.6227,164.7398 1531.6227,168.5618"
                      id="Fill-31"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M397.6875,874.4073 C393.8985,874.9053 390.4235,872.2373 389.9255,868.4473 C389.4275,864.6583 392.0955,861.1833 395.8845,860.6853 C399.6745,860.1873 403.1495,862.8553 403.6475,866.6453 C404.1445,870.4343 401.4765,873.9093 397.6875,874.4073"
                      id="Fill-33"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M269.2726,711.2987 C265.4836,711.7967 262.0086,709.1287 261.5106,705.3397 C261.0126,701.5497 263.6806,698.0747 267.4696,697.5767 C271.2596,697.0797 274.7346,699.7477 275.2326,703.5367 C275.7296,707.3257 273.0616,710.8007 269.2726,711.2987"
                      id="Fill-35"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M205.0865,881.3277 C201.2975,881.8257 197.8225,879.1577 197.3245,875.3687 C196.8265,871.5787 199.4945,868.1037 203.2835,867.6057 C207.0735,867.1087 210.5485,869.7767 211.0465,873.5657 C211.5435,877.3547 208.8755,880.8297 205.0865,881.3277"
                      id="Fill-37"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M121.0353,702.149 C117.2463,702.647 113.7713,699.979 113.2733,696.19 C112.7753,692.4 115.4433,688.925 119.2323,688.427 C123.0223,687.93 126.4973,690.598 126.9953,694.387 C127.4923,698.176 124.8243,701.651 121.0353,702.149"
                      id="Fill-39"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M173.8444,810.859 C170.0554,811.357 166.5804,808.689 166.0824,804.899 C165.5844,801.11 168.2524,797.635 172.0414,797.137 C175.8314,796.639 179.3064,799.307 179.8044,803.097 C180.3014,806.886 177.6334,810.361 173.8444,810.859"
                      id="Fill-41"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M166.5741,938.0794 C164.2551,938.3844 162.1281,936.7514 161.8231,934.4314 C161.5181,932.1124 163.1521,929.9854 165.4711,929.6814 C167.7901,929.3764 169.9171,931.0094 170.2221,933.3284 C170.5261,935.6474 168.8931,937.7744 166.5741,938.0794"
                      id="Fill-43"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M364.1241,892.0565 C361.8051,892.3615 359.6781,890.7285 359.3731,888.4095 C359.0681,886.0895 360.7021,883.9625 363.0211,883.6585 C365.3401,883.3535 367.4671,884.9865 367.7721,887.3055 C368.0761,889.6245 366.4431,891.7515 364.1241,892.0565"
                      id="Fill-45"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M73.8872,739.9534 C71.5682,740.2584 69.4412,738.6254 69.1362,736.3064 C68.8312,733.9864 70.4652,731.8594 72.7842,731.5554 C75.1032,731.2504 77.2302,732.8834 77.5352,735.2024 C77.8392,737.5214 76.2062,739.6484 73.8872,739.9534"
                      id="Fill-47"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M386.1815,709.7283 C383.8625,710.0333 381.7355,708.4003 381.4305,706.0813 C381.1255,703.7613 382.7595,701.6343 385.0785,701.3303 C387.3975,701.0253 389.5245,702.6583 389.8295,704.9773 C390.1335,707.2963 388.5005,709.4243 386.1815,709.7283"
                      id="Fill-49"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M264.5765,962.3746 C262.2575,962.6796 260.1305,961.0466 259.8255,958.7276 C259.5205,956.4076 261.1545,954.2806 263.4735,953.9766 C265.7925,953.6716 267.9195,955.3046 268.2245,957.6236 C268.5285,959.9426 266.8955,962.0696 264.5765,962.3746"
                      id="Fill-51"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M104.8905,830.7117 C102.5715,831.0167 100.4445,829.3837 100.1395,827.0637 C99.8345,824.7447 101.4685,822.6177 103.7875,822.3137 C106.1065,822.0087 108.2335,823.6417 108.5385,825.9607 C108.8425,828.2797 107.2095,830.4067 104.8905,830.7117"
                      id="Fill-53"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M268.098,635.8407 C265.779,636.1457 263.652,634.5127 263.347,632.1937 C263.042,629.8737 264.676,627.7467 266.995,627.4427 C269.314,627.1377 271.441,628.7707 271.746,631.0897 C272.05,633.4087 270.417,635.5357 268.098,635.8407"
                      id="Fill-55"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M260.6905,1043.794 C256.9015,1044.292 253.4265,1041.624 252.9285,1037.835 C252.4305,1034.045 255.0985,1030.57 258.8875,1030.072 C262.6775,1029.575 266.1525,1032.243 266.6505,1036.032 C267.1475,1039.821 264.4795,1043.296 260.6905,1043.794"
                      id="Fill-57"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M590.3201,587.0079 C586.5311,587.5059 583.0561,584.8379 582.5581,581.0479 C582.0601,577.2589 584.7281,573.7839 588.5171,573.2859 C592.3071,572.7879 595.7821,575.4559 596.2801,579.2459 C596.7771,583.0349 594.1091,586.5099 590.3201,587.0079"
                      id="Fill-59"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M661.6815,631.6051 C659.3625,631.9101 657.2355,630.2771 656.9305,627.9571 C656.6265,625.6381 658.2595,623.5111 660.5785,623.2071 C662.8975,622.9021 665.0245,624.5351 665.3295,626.8541 C665.6335,629.1731 664.0005,631.3001 661.6815,631.6051"
                      id="Fill-61"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M730.612,659.6668 C728.293,659.9718 726.166,658.3388 725.861,656.0198 C725.556,653.6998 727.19,651.5728 729.509,651.2688 C731.828,650.9638 733.955,652.5968 734.26,654.9158 C734.564,657.2348 732.931,659.3618 730.612,659.6668"
                      id="Fill-63"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M778.2805,567.3145 C775.9615,567.6195 773.8345,565.9865 773.5295,563.6675 C773.2245,561.3475 774.8585,559.2205 777.1775,558.9165 C779.4965,558.6115 781.6235,560.2445 781.9285,562.5635 C782.2325,564.8825 780.5995,567.0095 778.2805,567.3145"
                      id="Fill-65"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M932.7407,588.5819 C930.4217,588.8869 928.2947,587.2539 927.9897,584.9349 C927.6847,582.6149 929.3187,580.4879 931.6377,580.1839 C933.9567,579.8789 936.0837,581.5119 936.3887,583.8309 C936.6927,586.1499 935.0597,588.2769 932.7407,588.5819"
                      id="Fill-67"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M802.3921,631.6051 C800.0731,631.9101 797.9461,630.2771 797.6411,627.9571 C797.3361,625.6381 798.9701,623.5111 801.2891,623.2071 C803.6081,622.9021 805.7351,624.5351 806.0401,626.8541 C806.3441,629.1731 804.7111,631.3001 802.3921,631.6051"
                      id="Fill-69"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M469.6819,742.3731 C467.3629,742.6781 465.2359,741.0451 464.9309,738.7251 C464.6259,736.4061 466.2599,734.2791 468.5789,733.9751 C470.8979,733.6701 473.0249,735.3031 473.3299,737.6221 C473.6339,739.9411 472.0009,742.0681 469.6819,742.3731"
                      id="Fill-71"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M854.1204,544.0948 C854.1204,547.9168 851.0224,551.0148 847.2004,551.0148 C843.3784,551.0148 840.2804,547.9168 840.2804,544.0948 C840.2804,540.2728 843.3784,537.1748 847.2004,537.1748 C851.0224,537.1748 854.1204,540.2728 854.1204,544.0948"
                      id="Fill-73"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M605.0825,711.3585 C605.0825,715.1805 601.9845,718.2785 598.1625,718.2785 C594.3405,718.2785 591.2425,715.1805 591.2425,711.3585 C591.2425,707.5365 594.3405,704.4385 598.1625,704.4385 C601.9845,704.4385 605.0825,707.5365 605.0825,711.3585"
                      id="Fill-75"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1557.7424,490.8648 C1557.7424,494.6868 1554.6444,497.7848 1550.8224,497.7848 C1547.0004,497.7848 1543.9024,494.6868 1543.9024,490.8648 C1543.9024,487.0428 1547.0004,483.9448 1550.8224,483.9448 C1554.6444,483.9448 1557.7424,487.0428 1557.7424,490.8648"
                      id="Fill-77"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M499.3424,1099.9034 C499.3424,1103.7254 496.2444,1106.8234 492.4224,1106.8234 C488.6004,1106.8234 485.5024,1103.7254 485.5024,1099.9034 C485.5024,1096.0814 488.6004,1092.9834 492.4224,1092.9834 C496.2444,1092.9834 499.3424,1096.0814 499.3424,1099.9034"
                      id="Fill-85"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1200.4218,1535.5245 C1198.6728,1532.1265 1200.0108,1527.9535 1203.4088,1526.2055 C1206.8068,1524.4565 1210.9798,1525.7945 1212.7278,1529.1925 C1214.4768,1532.5905 1213.1388,1536.7635 1209.7408,1538.5115 C1206.3428,1540.2605 1202.1708,1538.9225 1200.4218,1535.5245"
                      id="Fill-87"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1361.053,1335.1715 C1359.304,1331.7735 1360.642,1327.6005 1364.04,1325.8525 C1367.438,1324.1035 1371.61,1325.4415 1373.359,1328.8395 C1375.108,1332.2375 1373.77,1336.4095 1370.372,1338.1585 C1366.974,1339.9075 1362.802,1338.5695 1361.053,1335.1715"
                      id="Fill-89"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1222.9646,1485.5103 C1221.8946,1483.4303 1222.7126,1480.8763 1224.7926,1479.8063 C1226.8726,1478.7363 1229.4266,1479.5543 1230.4966,1481.6343 C1231.5666,1483.7143 1230.7486,1486.2683 1228.6686,1487.3383 C1226.5886,1488.4083 1224.0346,1487.5903 1222.9646,1485.5103"
                      id="Fill-91"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1402.025,1444.6768 C1400.955,1442.5968 1401.773,1440.0428 1403.853,1438.9728 C1405.933,1437.9028 1408.487,1438.7208 1409.557,1440.8008 C1410.627,1442.8808 1409.809,1445.4348 1407.729,1446.5048 C1405.649,1447.5748 1403.095,1446.7568 1402.025,1444.6768"
                      id="Fill-93"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1485.3169,1312.8109 C1484.2469,1310.7309 1485.0649,1308.1769 1487.1449,1307.1069 C1489.2249,1306.0369 1491.7789,1306.8549 1492.8489,1308.9349 C1493.9189,1311.0149 1493.1009,1313.5689 1491.0209,1314.6389 C1488.9409,1315.7089 1486.3869,1314.8909 1485.3169,1312.8109"
                      id="Fill-95"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1544.6696,1490.9747 C1542.9206,1487.5767 1544.2586,1483.4037 1547.6566,1481.6557 C1551.0546,1479.9067 1555.2266,1481.2447 1556.9756,1484.6427 C1558.7246,1488.0407 1557.3866,1492.2137 1553.9886,1493.9617 C1550.5906,1495.7107 1546.4186,1494.3727 1544.6696,1490.9747"
                      id="Fill-97"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1399.5078,1534.2962 C1398.4378,1532.2162 1399.2558,1529.6622 1401.3358,1528.5922 C1403.4158,1527.5222 1405.9698,1528.3402 1407.0398,1530.4212 C1408.1098,1532.5002 1407.2918,1535.0542 1405.2118,1536.1242 C1403.1318,1537.1942 1400.5778,1536.3762 1399.5078,1534.2962"
                      id="Fill-99"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1474.4403,1651.2595 C1470.8433,1652.5505 1466.8803,1650.6815 1465.5893,1647.0845 C1464.2983,1643.4875 1466.1683,1639.5245 1469.7653,1638.2335 C1473.3623,1636.9425 1477.3243,1638.8115 1478.6153,1642.4085 C1479.9063,1646.0055 1478.0373,1649.9685 1474.4403,1651.2595"
                      id="Fill-101"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1040.3545,1327.2149 C1038.0355,1327.5199 1035.9085,1325.8869 1035.6035,1323.5679 C1035.2985,1321.2479 1036.9325,1319.1209 1039.2515,1318.8169 C1041.5705,1318.5119 1043.6975,1320.1449 1044.0015,1322.4639 C1044.3065,1324.7829 1042.6735,1326.9109 1040.3545,1327.2149"
                      id="Fill-103"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1123.8549,1359.8597 C1121.5359,1360.1647 1119.4089,1358.5317 1119.1039,1356.2117 C1118.7989,1353.8927 1120.4329,1351.7657 1122.7519,1351.4617 C1125.0709,1351.1567 1127.1979,1352.7897 1127.5029,1355.1087 C1127.8069,1357.4277 1126.1739,1359.5547 1123.8549,1359.8597"
                      id="Fill-105"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M675.2253,1277.284 C673.0433,1274.147 673.8173,1269.834 676.9553,1267.652 C680.0923,1265.47 684.4053,1266.244 686.5873,1269.382 C688.7693,1272.519 687.9953,1276.832 684.8573,1279.014 C681.7203,1281.196 677.4073,1280.421 675.2253,1277.284"
                      id="Fill-107"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M723.4796,1217.172 C721.2976,1214.035 722.0716,1209.722 725.2096,1207.54 C728.3466,1205.358 732.6596,1206.132 734.8416,1209.27 C737.0236,1212.407 736.2496,1216.72 733.1116,1218.902 C729.9746,1221.084 725.6616,1220.309 723.4796,1217.172"
                      id="Fill-109"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M674.1808,1165.0335 C672.8448,1163.1135 673.3188,1160.4735 675.2398,1159.1385 C677.1598,1157.8025 679.7988,1158.2765 681.1348,1160.1975 C682.4708,1162.1175 681.9968,1164.7565 680.0758,1166.0925 C678.1558,1167.4275 675.5168,1166.9535 674.1808,1165.0335"
                      id="Fill-111"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M805.4266,1255.8358 C801.6376,1256.3338 798.1626,1253.6658 797.6646,1249.8768 C797.1666,1246.0868 799.8346,1242.6118 803.6236,1242.1138 C807.4136,1241.6168 810.8886,1244.2848 811.3866,1248.0738 C811.8836,1251.8628 809.2156,1255.3378 805.4266,1255.8358"
                      id="Fill-113"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M886.5018,1244.6795 C882.7128,1245.1775 879.2378,1242.5095 878.7398,1238.7195 C878.2418,1234.9305 880.9098,1231.4555 884.6988,1230.9575 C888.4888,1230.4595 891.9638,1233.1275 892.4618,1236.9175 C892.9588,1240.7065 890.2908,1244.1815 886.5018,1244.6795"
                      id="Fill-115"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M988.9283,1217.42 C986.6093,1217.725 984.4823,1216.092 984.1773,1213.773 C983.8723,1211.453 985.5063,1209.326 987.8253,1209.022 C990.1443,1208.717 992.2713,1210.35 992.5763,1212.669 C992.8803,1214.988 991.2473,1217.115 988.9283,1217.42"
                      id="Fill-117"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M589.6951,1253.1741 C587.3761,1253.4791 585.2491,1251.8461 584.9441,1249.5271 C584.6401,1247.2071 586.2731,1245.0801 588.5921,1244.7761 C590.9111,1244.4711 593.0381,1246.1041 593.3431,1248.4231 C593.6471,1250.7421 592.0141,1252.8691 589.6951,1253.1741"
                      id="Fill-119"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M682.4452,1097.1827 C680.1262,1097.4877 677.9992,1095.8547 677.6942,1093.5357 C677.3892,1091.2157 679.0232,1089.0887 681.3422,1088.7847 C683.6612,1088.4797 685.7882,1090.1127 686.0932,1092.4317 C686.3972,1094.7507 684.7642,1096.8777 682.4452,1097.1827"
                      id="Fill-121"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M886.1521,1311.9139 C883.8331,1312.2189 881.7061,1310.5859 881.4011,1308.2669 C881.0961,1305.9469 882.7301,1303.8199 885.0491,1303.5159 C887.3681,1303.2109 889.4951,1304.8439 889.8001,1307.1629 C890.1041,1309.4819 888.4711,1311.6089 886.1521,1311.9139"
                      id="Fill-123"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M534.5873,942.315 C532.2683,942.62 530.1413,940.987 529.8363,938.668 C529.5313,936.348 531.1653,934.221 533.4843,933.917 C535.8033,933.612 537.9303,935.245 538.2353,937.564 C538.5393,939.883 536.9063,942.01 534.5873,942.315"
                      id="Fill-125"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1465.7325,1519.7252 C1463.4135,1520.0302 1461.2865,1518.3972 1460.9815,1516.0782 C1460.6765,1513.7582 1462.3105,1511.6312 1464.6295,1511.3272 C1466.9485,1511.0222 1469.0755,1512.6552 1469.3795,1514.9742 C1469.6845,1517.2932 1468.0515,1519.4202 1465.7325,1519.7252"
                      id="Fill-127"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1260.6818,1306.6451 C1258.9328,1303.2471 1260.2708,1299.0741 1263.6688,1297.3261 C1267.0668,1295.5771 1271.2388,1296.9151 1272.9878,1300.3131 C1274.7368,1303.7111 1273.3988,1307.8831 1270.0008,1309.6321 C1266.6028,1311.3801 1262.4308,1310.0431 1260.6818,1306.6451"
                      id="Fill-129"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1274.5244,1708.2108 C1272.7754,1704.8128 1274.1134,1700.6398 1277.5114,1698.8918 C1280.9094,1697.1428 1285.0814,1698.4808 1286.8304,1701.8788 C1288.5794,1705.2768 1287.2414,1709.4488 1283.8434,1711.1978 C1280.4454,1712.9468 1276.2734,1711.6088 1274.5244,1708.2108"
                      id="Fill-131"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1574.0342,1417.0452 C1572.2852,1413.6472 1573.6232,1409.4742 1577.0212,1407.7262 C1580.4192,1405.9772 1584.5922,1407.3152 1586.3402,1410.7132 C1588.0892,1414.1112 1586.7512,1418.2832 1583.3532,1420.0322 C1579.9552,1421.7812 1575.7832,1420.4432 1574.0342,1417.0452"
                      id="Fill-133"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M927.8795,1808.7252 C930.2375,1805.7172 934.5865,1805.1902 937.5945,1807.5482 C940.6025,1809.9052 941.1295,1814.2552 938.7715,1817.2632 C936.4145,1820.2712 932.0645,1820.7982 929.0565,1818.4402 C926.0485,1816.0822 925.5215,1811.7332 927.8795,1808.7252"
                      id="Fill-135"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M845.6985,1826.8262 C847.1415,1824.9852 849.8035,1824.6622 851.6445,1826.1062 C853.4855,1827.5492 853.8085,1830.2112 852.3655,1832.0522 C850.9225,1833.8932 848.2595,1834.2152 846.4195,1832.7722 C844.5785,1831.3292 844.2555,1828.6672 845.6985,1826.8262"
                      id="Fill-137"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M687.9339,1861.915 C689.3769,1860.074 692.0389,1859.752 693.8799,1861.195 C695.7209,1862.638 696.0439,1865.3 694.6009,1867.141 C693.1579,1868.982 690.4949,1869.304 688.6549,1867.861 C686.8139,1866.418 686.4909,1863.756 687.9339,1861.915"
                      id="Fill-139"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M718.5347,1961.2368 C719.9777,1959.3958 722.6397,1959.0728 724.4807,1960.5158 C726.3217,1961.9598 726.6447,1964.6218 725.2017,1966.4628 C723.7587,1968.3038 721.0957,1968.6258 719.2557,1967.1828 C717.4147,1965.7398 717.0917,1963.0778 718.5347,1961.2368"
                      id="Fill-141"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M553.3375,2054.1665 C554.7805,2052.3255 557.4425,2052.0025 559.2835,2053.4455 C561.1245,2054.8885 561.4475,2057.5515 560.0045,2059.3925 C558.5615,2061.2335 555.8985,2061.5555 554.0585,2060.1125 C552.2175,2058.6695 551.8945,2056.0075 553.3375,2054.1665"
                      id="Fill-143"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M656.3134,1932.2 C657.7564,1930.359 660.4184,1930.037 662.2594,1931.48 C664.1004,1932.923 664.4234,1935.585 662.9804,1937.426 C661.5374,1939.267 658.8744,1939.589 657.0344,1938.146 C655.1934,1936.703 654.8704,1934.041 656.3134,1932.2"
                      id="Fill-145"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1105.993,1731.0299 C1104.244,1727.6319 1105.582,1723.4589 1108.98,1721.7109 C1112.378,1719.9619 1116.55,1721.2999 1118.299,1724.6979 C1120.048,1728.0959 1118.71,1732.2679 1115.312,1734.0169 C1111.914,1735.7659 1107.742,1734.4279 1105.993,1731.0299"
                      id="Fill-147"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1077.7174,1880.248 C1075.9684,1876.85 1077.3064,1872.677 1080.7044,1870.929 C1084.1024,1869.18 1088.2754,1870.518 1090.0234,1873.916 C1091.7724,1877.314 1090.4344,1881.486 1087.0364,1883.235 C1083.6384,1884.984 1079.4664,1883.646 1077.7174,1880.248"
                      id="Fill-149"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M889.1877,1903.7291 C890.6307,1901.8881 893.2927,1901.5661 895.1337,1903.0091 C896.9747,1904.4521 897.2977,1907.1141 895.8547,1908.9551 C894.4117,1910.7961 891.7487,1911.1181 889.9087,1909.6751 C888.0677,1908.2321 887.7447,1905.5701 889.1877,1903.7291"
                      id="Fill-151"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1254.1252,1751.7833 C1255.5682,1749.9423 1258.2302,1749.6203 1260.0712,1751.0633 C1261.9122,1752.5063 1262.2352,1755.1683 1260.7922,1757.0093 C1259.3492,1758.8503 1256.6862,1759.1723 1254.8452,1757.7293 C1253.0052,1756.2863 1252.6822,1753.6243 1254.1252,1751.7833"
                      id="Fill-153"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1315.9054,1584.9847 C1317.3484,1583.1437 1320.0104,1582.8207 1321.8514,1584.2647 C1323.6924,1585.7067 1324.0154,1588.3697 1322.5724,1590.2107 C1321.1294,1592.0507 1318.4674,1592.3737 1316.6264,1590.9307 C1314.7854,1589.4877 1314.4624,1586.8257 1315.9054,1584.9847"
                      id="Fill-155"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M500.5202,2229.5936 C496.7312,2229.0926 494.0662,2225.6156 494.5662,2221.8266 C495.0672,2218.0376 498.5442,2215.3726 502.3332,2215.8736 C506.1222,2216.3736 508.7882,2219.8516 508.2872,2223.6396 C507.7862,2227.4286 504.3092,2230.0946 500.5202,2229.5936"
                      id="Fill-157"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M447.9546,2074.7955 C444.1656,2074.2945 441.5006,2070.8175 442.0006,2067.0285 C442.5016,2063.2395 445.9786,2060.5745 449.7676,2061.0755 C453.5566,2061.5755 456.2226,2065.0535 455.7216,2068.8425 C455.2206,2072.6305 451.7436,2075.2965 447.9546,2074.7955"
                      id="Fill-159"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M267.9089,2074.7955 C264.1199,2074.2945 261.4549,2070.8175 261.9549,2067.0285 C262.4559,2063.2395 265.9329,2060.5745 269.7219,2061.0755 C273.5109,2061.5755 276.1769,2065.0535 275.6759,2068.8425 C275.1749,2072.6305 271.6979,2075.2965 267.9089,2074.7955"
                      id="Fill-161"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M305.2623,2173.7136 C301.4733,2173.2126 298.8083,2169.7356 299.3083,2165.9466 C299.8093,2162.1576 303.2863,2159.4926 307.0753,2159.9936 C310.8643,2160.4936 313.5303,2163.9716 313.0293,2167.7596 C312.5283,2171.5486 309.0513,2174.2146 305.2623,2173.7136"
                      id="Fill-163"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M305.2623,1924.3582 C301.4733,1923.8572 298.8083,1920.3802 299.3083,1916.5912 C299.8093,1912.8022 303.2863,1910.1372 307.0753,1910.6382 C310.8643,1911.1382 313.5303,1914.6162 313.0293,1918.4042 C312.5283,1922.1932 309.0513,1924.8592 305.2623,1924.3582"
                      id="Fill-165"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M210.5114,2216.5249 C206.7224,2216.0239 204.0574,2212.5469 204.5574,2208.7579 C205.0584,2204.9689 208.5354,2202.3039 212.3244,2202.8049 C216.1134,2203.3049 218.7794,2206.7829 218.2784,2210.5709 C217.7774,2214.3599 214.3004,2217.0259 210.5114,2216.5249"
                      id="Fill-167"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M147.8132,2319.3468 C145.4942,2319.0398 143.8632,2316.9118 144.1692,2314.5928 C144.4762,2312.2738 146.6042,2310.6428 148.9232,2310.9488 C151.2422,2311.2558 152.8732,2313.3838 152.5672,2315.7028 C152.2602,2318.0218 150.1322,2319.6528 147.8132,2319.3468"
                      id="Fill-169"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M463.5305,2237.9464 C461.2115,2237.6404 459.5805,2235.5114 459.8865,2233.1924 C460.1935,2230.8734 462.3215,2229.2424 464.6405,2229.5494 C466.9595,2229.8554 468.5905,2231.9834 468.2845,2234.3024 C467.9775,2236.6214 465.8495,2238.2534 463.5305,2237.9464"
                      id="Fill-171"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M222.5993,2015.8543 C220.2803,2015.5483 218.6493,2013.4193 218.9553,2011.1003 C219.2623,2008.7813 221.3903,2007.1503 223.7093,2007.4563 C226.0283,2007.7633 227.6593,2009.8913 227.3533,2012.2103 C227.0463,2014.5293 224.9183,2016.1613 222.5993,2015.8543"
                      id="Fill-173"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M384.1149,2136.3127 C381.7959,2136.0067 380.1649,2133.8777 380.4709,2131.5587 C380.7779,2129.2397 382.9059,2127.6087 385.2249,2127.9147 C387.5439,2128.2217 389.1749,2130.3497 388.8689,2132.6687 C388.5619,2134.9877 386.4339,2136.6197 384.1149,2136.3127"
                      id="Fill-175"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M349.166,2280.0787 C346.847,2279.7717 345.216,2277.6437 345.522,2275.3247 C345.829,2273.0057 347.957,2271.3747 350.276,2271.6807 C352.595,2271.9877 354.226,2274.1157 353.92,2276.4347 C353.613,2278.7537 351.485,2280.3847 349.166,2280.0787"
                      id="Fill-177"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M152.049,2111.5457 C149.73,2111.2397 148.099,2109.1107 148.405,2106.7917 C148.712,2104.4727 150.84,2102.8417 153.159,2103.1477 C155.478,2103.4547 157.109,2105.5827 156.803,2107.9017 C156.496,2110.2207 154.368,2111.8527 152.049,2111.5457"
                      id="Fill-179"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M437.1499,1965.6019 C434.8309,1965.2949 433.1999,1963.1669 433.5059,1960.8479 C433.8129,1958.5289 435.9409,1956.8979 438.2599,1957.2039 C440.5789,1957.5109 442.2099,1959.6389 441.9039,1961.9579 C441.5969,1964.2769 439.4689,1965.9079 437.1499,1965.6019"
                      id="Fill-181"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M80.3131,1969.7087 C77.9941,1969.4027 76.3631,1967.2737 76.6691,1964.9547 C76.9761,1962.6357 79.1041,1961.0047 81.4231,1961.3117 C83.7421,1961.6177 85.3731,1963.7457 85.0671,1966.0647 C84.7601,1968.3837 82.6321,1970.0157 80.3131,1969.7087"
                      id="Fill-183"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M395.9376,2362.5882 C392.1486,2362.0872 389.4836,2358.6102 389.9836,2354.8212 C390.4846,2351.0322 393.9616,2348.3672 397.7506,2348.8682 C401.5396,2349.3682 404.2056,2352.8462 403.7046,2356.6342 C403.2036,2360.4232 399.7266,2363.0892 395.9376,2362.5882"
                      id="Fill-185"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M72.9907,2346.2554 C69.2017,2345.7544 66.5367,2342.2774 67.0367,2338.4884 C67.5377,2334.6994 71.0147,2332.0344 74.8037,2332.5354 C78.5927,2333.0354 81.2587,2336.5134 80.7577,2340.3014 C80.2567,2344.0904 76.7797,2346.7564 72.9907,2346.2554"
                      id="Fill-187"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M607.5511,1995.1015 C603.7621,1994.6005 601.0971,1991.1235 601.5971,1987.3345 C602.0981,1983.5455 605.5751,1980.8805 609.3641,1981.3815 C613.1531,1981.8815 615.8191,1985.3595 615.3181,1989.1485 C614.8171,1992.9365 611.3401,1995.6025 607.5511,1995.1015"
                      id="Fill-189"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M793.0728,2533.3065 C795.3808,2533.6845 796.9458,2535.8615 796.5678,2538.1705 C796.1908,2540.4785 794.0128,2542.0435 791.7048,2541.6655 C789.3958,2541.2875 787.8308,2539.1105 788.2088,2536.8015 C788.5868,2534.4935 790.7648,2532.9285 793.0728,2533.3065"
                      id="Fill-191"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M722.5527,2477.9449 C724.8607,2478.3229 726.4257,2480.4999 726.0477,2482.8089 C725.6707,2485.1169 723.4927,2486.6819 721.1847,2486.3039 C718.8757,2485.9259 717.3107,2483.7489 717.6887,2481.4399 C718.0667,2479.1319 720.2447,2477.5669 722.5527,2477.9449"
                      id="Fill-193"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M508.0065,2495.7309 C509.1895,2499.3649 507.2035,2503.2699 503.5695,2504.4529 C499.9355,2505.6369 496.0305,2503.6499 494.8475,2500.0169 C493.6635,2496.3829 495.6505,2492.4769 499.2835,2491.2939 C502.9175,2490.1109 506.8235,2492.0969 508.0065,2495.7309"
                      id="Fill-195"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1030.5355,2716.304 C1031.7185,2719.938 1029.7325,2723.843 1026.0985,2725.026 C1022.4645,2726.21 1018.5595,2724.223 1017.3765,2720.59 C1016.1925,2716.956 1018.1795,2713.05 1021.8135,2711.867 C1025.4465,2710.684 1029.3525,2712.67 1030.5355,2716.304"
                      id="Fill-197"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M896.8304,2594.0618 C900.6024,2594.6788 903.1584,2598.2368 902.5414,2602.0088 C901.9244,2605.7798 898.3664,2608.3368 894.5944,2607.7198 C890.8234,2607.1028 888.2664,2603.5448 888.8834,2599.7728 C889.5014,2596.0018 893.0584,2593.4448 896.8304,2594.0618"
                      id="Fill-199"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1011.231,2600.9827 C1015.003,2601.5997 1017.559,2605.1577 1016.942,2608.9297 C1016.325,2612.7007 1012.767,2615.2577 1008.995,2614.6407 C1005.224,2614.0237 1002.667,2610.4657 1003.284,2606.6937 C1003.902,2602.9227 1007.459,2600.3657 1011.231,2600.9827"
                      id="Fill-201"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M810.6105,2653.2732 C812.9185,2653.6512 814.4835,2655.8282 814.1055,2658.1372 C813.7285,2660.4452 811.5505,2662.0102 809.2425,2661.6322 C806.9335,2661.2542 805.3685,2659.0772 805.7465,2656.7682 C806.1245,2654.4602 808.3025,2652.8952 810.6105,2653.2732"
                      id="Fill-203"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M971.893,2561.013 C974.201,2561.391 975.766,2563.568 975.388,2565.877 C975.011,2568.185 972.833,2569.75 970.525,2569.372 C968.216,2568.994 966.651,2566.817 967.029,2564.508 C967.407,2562.2 969.585,2560.635 971.893,2561.013"
                      id="Fill-205"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M681.3163,2353.1761 C677.5273,2352.6751 674.8623,2349.1981 675.3623,2345.4091 C675.8633,2341.6201 679.3403,2338.9551 683.1293,2339.4561 C686.9183,2339.9561 689.5843,2343.4341 689.0833,2347.2221 C688.5823,2351.0111 685.1053,2353.6771 681.3163,2353.1761"
                      id="Fill-207"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M670.5117,2550.1566 C668.1927,2549.8506 666.5617,2547.7216 666.8677,2545.4026 C667.1747,2543.0836 669.3027,2541.4526 671.6217,2541.7586 C673.9407,2542.0656 675.5717,2544.1936 675.2657,2546.5126 C674.9587,2548.8316 672.8307,2550.4636 670.5117,2550.1566"
                      id="Fill-209"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M600.9821,2359.9268 C598.6631,2359.6198 597.0321,2357.4918 597.3381,2355.1728 C597.6451,2352.8538 599.7731,2351.2228 602.0921,2351.5288 C604.4111,2351.8358 606.0421,2353.9638 605.7361,2356.2828 C605.4291,2358.6018 603.3011,2360.2328 600.9821,2359.9268"
                      id="Fill-211"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1268.3126,2907.3441 C1269.2746,2903.6451 1273.0536,2901.4271 1276.7516,2902.3891 C1280.4506,2903.3521 1282.6686,2907.1301 1281.7066,2910.8291 C1280.7446,2914.5271 1276.9656,2916.7461 1273.2666,2915.7831 C1269.5686,2914.8211 1267.3506,2911.0431 1268.3126,2907.3441"
                      id="Fill-213"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1361.0267,2835.7752 C1361.9887,2832.0762 1365.7677,2829.8582 1369.4657,2830.8202 C1373.1647,2831.7832 1375.3827,2835.5612 1374.4207,2839.2602 C1373.4587,2842.9582 1369.6797,2845.1772 1365.9807,2844.2142 C1362.2827,2843.2522 1360.0647,2839.4742 1361.0267,2835.7752"
                      id="Fill-215"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1236.0402,2733.1748 C1237.0022,2729.4758 1240.7812,2727.2578 1244.4792,2728.2208 C1248.1782,2729.1828 1250.3962,2732.9608 1249.4342,2736.6598 C1248.4722,2740.3578 1244.6932,2742.5768 1240.9942,2741.6138 C1237.2962,2740.6518 1235.0782,2736.8738 1236.0402,2733.1748"
                      id="Fill-217"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1427.3729,2776.0341 C1428.3349,2772.3351 1432.1139,2770.1171 1435.8119,2771.0801 C1439.5109,2772.0421 1441.7289,2775.8201 1440.7669,2779.5191 C1439.8049,2783.2171 1436.0259,2785.4361 1432.3269,2784.4731 C1428.6289,2783.5111 1426.4109,2779.7331 1427.3729,2776.0341"
                      id="Fill-219"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1459.9052,2691.4826 C1460.8672,2687.7836 1464.6462,2685.5656 1468.3442,2686.5276 C1472.0432,2687.4906 1474.2612,2691.2686 1473.2992,2694.9676 C1472.3372,2698.6656 1468.5582,2700.8846 1464.8592,2699.9216 C1461.1612,2698.9596 1458.9432,2695.1816 1459.9052,2691.4826"
                      id="Fill-221"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1296.1365,2669.2402 C1296.7255,2666.9762 1299.0375,2665.6192 1301.3015,2666.2082 C1303.5655,2666.7972 1304.9235,2669.1092 1304.3345,2671.3732 C1303.7455,2673.6372 1301.4325,2674.9942 1299.1685,2674.4052 C1296.9055,2673.8162 1295.5475,2671.5042 1296.1365,2669.2402"
                      id="Fill-223"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1264.5664,2869.6085 C1265.1554,2867.3445 1267.4684,2865.9875 1269.7314,2866.5765 C1271.9954,2867.1655 1273.3534,2869.4775 1272.7644,2871.7415 C1272.1754,2874.0055 1269.8624,2875.3625 1267.5984,2874.7735 C1265.3354,2874.1845 1263.9774,2871.8725 1264.5664,2869.6085"
                      id="Fill-225"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1614.3425,2724.302 C1614.9315,2722.038 1617.2435,2720.681 1619.5075,2721.27 C1621.7715,2721.859 1623.1295,2724.171 1622.5405,2726.435 C1621.9515,2728.699 1619.6385,2730.056 1617.3745,2729.467 C1615.1115,2728.878 1613.7535,2726.566 1614.3425,2724.302"
                      id="Fill-227"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1485.6727,2987.6284 C1486.2617,2985.3644 1488.5737,2984.0074 1490.8377,2984.5964 C1493.1017,2985.1854 1494.4597,2987.4974 1493.8707,2989.7614 C1493.2817,2992.0254 1490.9687,2993.3824 1488.7047,2992.7934 C1486.4417,2992.2044 1485.0837,2989.8924 1485.6727,2987.6284"
                      id="Fill-229"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1133.297,2780.9464 C1133.886,2778.6824 1136.198,2777.3254 1138.462,2777.9144 C1140.726,2778.5034 1142.084,2780.8154 1141.495,2783.0794 C1140.906,2785.3434 1138.593,2786.7004 1136.329,2786.1114 C1134.066,2785.5224 1132.708,2783.2104 1133.297,2780.9464"
                      id="Fill-231"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1414.5768,2592.9035 C1415.1658,2590.6395 1417.4788,2589.2825 1419.7418,2589.8715 C1422.0058,2590.4605 1423.3638,2592.7725 1422.7748,2595.0365 C1422.1858,2597.3005 1419.8728,2598.6575 1417.6088,2598.0685 C1415.3458,2597.4795 1413.9878,2595.1675 1414.5768,2592.9035"
                      id="Fill-233"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1538.0891,2876.8799 C1538.6781,2874.6159 1540.9901,2873.2589 1543.2541,2873.8479 C1545.5181,2874.4369 1546.8761,2876.7489 1546.2871,2879.0129 C1545.6981,2881.2769 1543.3851,2882.6339 1541.1211,2882.0449 C1538.8581,2881.4559 1537.5001,2879.1439 1538.0891,2876.8799"
                      id="Fill-235"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1363.6248,3023.6702 C1364.2138,3021.4062 1366.5268,3020.0492 1368.7898,3020.6382 C1371.0538,3021.2272 1372.4118,3023.5392 1371.8228,3025.8032 C1371.2338,3028.0672 1368.9208,3029.4242 1366.6568,3028.8352 C1364.3938,3028.2462 1363.0358,3025.9342 1363.6248,3023.6702"
                      id="Fill-237"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1067.7024,2935.8151 C1067.3014,2939.6161 1063.8944,2942.3711 1060.0944,2941.9701 C1056.2934,2941.5691 1053.5374,2938.1631 1053.9394,2934.3621 C1054.3404,2930.5611 1057.7464,2927.8061 1061.5474,2928.2071 C1065.3484,2928.6081 1068.1034,2932.0141 1067.7024,2935.8151"
                      id="Fill-239"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1192.2351,2689.434 C1191.9891,2691.76 1189.9051,2693.447 1187.5791,2693.201 C1185.2521,2692.956 1183.5661,2690.871 1183.8111,2688.545 C1184.0571,2686.218 1186.1421,2684.532 1188.4681,2684.777 C1190.7941,2685.023 1192.4811,2687.108 1192.2351,2689.434"
                      id="Fill-241"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1167.9938,3068.4 C1171.7648,3069.017 1174.3218,3072.575 1173.7048,3076.347 C1173.0878,3080.118 1169.5298,3082.675 1165.7578,3082.058 C1161.9868,3081.441 1159.4298,3077.883 1160.0468,3074.111 C1160.6648,3070.34 1164.2218,3067.783 1167.9938,3068.4"
                      id="Fill-243"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1207.2637,3051.3058 C1209.5717,3051.6838 1211.1367,3053.8608 1210.7587,3056.1698 C1210.3817,3058.4778 1208.2037,3060.0428 1205.8957,3059.6648 C1203.5867,3059.2878 1202.0217,3057.1098 1202.3997,3054.8008 C1202.7777,3052.4928 1204.9557,3050.9278 1207.2637,3051.3058"
                      id="Fill-245"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1374.8698,3181.6392 C1375.8318,3177.9402 1379.6108,3175.7222 1383.3088,3176.6852 C1387.0078,3177.6472 1389.2258,3181.4252 1388.2638,3185.1242 C1387.3018,3188.8222 1383.5228,3191.0412 1379.8248,3190.0782 C1376.1258,3189.1162 1373.9078,3185.3382 1374.8698,3181.6392"
                      id="Fill-247"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M880.5977,3177.4038 C881.5597,3173.7048 885.3387,3171.4868 889.0367,3172.4498 C892.7357,3173.4118 894.9537,3177.1898 893.9917,3180.8888 C893.0297,3184.5868 889.2507,3186.8058 885.5517,3185.8428 C881.8537,3184.8808 879.6357,3181.1028 880.5977,3177.4038"
                      id="Fill-249"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M959.1149,3176.5334 C960.5579,3174.6924 963.2199,3174.3694 965.0609,3175.8124 C966.9019,3177.2554 967.2249,3179.9184 965.7819,3181.7594 C964.3389,3183.5994 961.6759,3183.9224 959.8359,3182.4794 C957.9949,3181.0364 957.6719,3178.3744 959.1149,3176.5334"
                      id="Fill-251"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1003.3504,3084.4088 C1004.7934,3082.5678 1007.4554,3082.2448 1009.2964,3083.6878 C1011.1374,3085.1308 1011.4604,3087.7938 1010.0174,3089.6348 C1008.5744,3091.4758 1005.9114,3091.7978 1004.0714,3090.3548 C1002.2304,3088.9118 1001.9074,3086.2498 1003.3504,3084.4088"
                      id="Fill-253"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M794.9916,3227.0042 C791.2026,3226.5032 788.5376,3223.0262 789.0376,3219.2372 C789.5386,3215.4482 793.0156,3212.7832 796.8046,3213.2842 C800.5936,3213.7842 803.2596,3217.2622 802.7586,3221.0502 C802.2576,3224.8392 798.7806,3227.5052 794.9916,3227.0042"
                      id="Fill-255"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M784.187,3117.8105 C781.868,3117.5045 780.237,3115.3755 780.543,3113.0565 C780.85,3110.7375 782.978,3109.1065 785.297,3109.4125 C787.616,3109.7195 789.247,3111.8475 788.941,3114.1665 C788.634,3116.4855 786.506,3118.1165 784.187,3117.8105"
                      id="Fill-257"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M683.8817,3211.6126 C680.0927,3211.1116 677.4277,3207.6346 677.9277,3203.8456 C678.4287,3200.0566 681.9057,3197.3916 685.6947,3197.8926 C689.4837,3198.3926 692.1497,3201.8706 691.6487,3205.6586 C691.1477,3209.4476 687.6707,3212.1136 683.8817,3211.6126"
                      id="Fill-259"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M172.1984,3214.2057 C175.4784,3212.2437 179.7274,3213.3127 181.6894,3216.5927 C183.6504,3219.8717 182.5824,3224.1207 179.3024,3226.0827 C176.0224,3228.0447 171.7734,3226.9757 169.8114,3223.6967 C167.8504,3220.4167 168.9184,3216.1677 172.1984,3214.2057"
                      id="Fill-261"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M609.4598,3354.8105 C612.7398,3352.8485 616.9888,3353.9175 618.9508,3357.1975 C620.9118,3360.4765 619.8438,3364.7255 616.5638,3366.6875 C613.2838,3368.6495 609.0348,3367.5815 607.0728,3364.3015 C605.1118,3361.0215 606.1798,3356.7725 609.4598,3354.8105"
                      id="Fill-263"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M223.5486,3233.5127 C225.5556,3232.3117 228.1566,3232.9657 229.3576,3234.9737 C230.5576,3236.9807 229.9036,3239.5817 227.8966,3240.7817 C225.8896,3241.9827 223.2886,3241.3287 222.0876,3239.3217 C220.8876,3237.3137 221.5416,3234.7137 223.5486,3233.5127"
                      id="Fill-265"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M345.178,3516.2749 C347.185,3515.0739 349.786,3515.7279 350.987,3517.7359 C352.187,3519.7429 351.533,3522.3439 349.526,3523.5439 C347.519,3524.7449 344.918,3524.0909 343.717,3522.0839 C342.517,3520.0759 343.171,3517.4759 345.178,3516.2749"
                      id="Fill-267"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M412.6292,3484.3162 C414.6362,3483.1152 417.2372,3483.7692 418.4382,3485.7772 C419.6382,3487.7842 418.9842,3490.3852 416.9772,3491.5852 C414.9702,3492.7862 412.3692,3492.1322 411.1682,3490.1252 C409.9682,3488.1172 410.6222,3485.5172 412.6292,3484.3162"
                      id="Fill-269"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M195.9006,3575.5505 C199.1806,3573.5885 203.4296,3574.6575 205.3916,3577.9375 C207.3526,3581.2165 206.2846,3585.4655 203.0046,3587.4275 C199.7246,3589.3895 195.4756,3588.3215 193.5136,3585.0415 C191.5526,3581.7615 192.6206,3577.5125 195.9006,3575.5505"
                      id="Fill-271"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M186.1217,3412.808 C188.1287,3411.607 190.7297,3412.261 191.9307,3414.269 C193.1307,3416.276 192.4767,3418.877 190.4697,3420.077 C188.4627,3421.278 185.8617,3420.624 184.6607,3418.617 C183.4607,3416.609 184.1147,3414.009 186.1217,3412.808"
                      id="Fill-273"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M160.438,3469.4964 C159.986,3467.2014 161.48,3464.9744 163.775,3464.5224 C166.07,3464.0704 168.297,3465.5644 168.749,3467.8594 C169.201,3470.1544 167.707,3472.3814 165.412,3472.8334 C163.117,3473.2854 160.89,3471.7914 160.438,3469.4964"
                      id="Fill-275"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M404.4553,3259.7452 C407.7353,3257.7832 411.9843,3258.8522 413.9463,3262.1322 C415.9073,3265.4112 414.8393,3269.6602 411.5593,3271.6222 C408.2793,3273.5842 404.0303,3272.5162 402.0683,3269.2362 C400.1073,3265.9562 401.1753,3261.7072 404.4553,3259.7452"
                      id="Fill-277"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M130.2044,3332.6087 C132.1334,3333.9317 132.6254,3336.5677 131.3024,3338.4967 C129.9804,3340.4257 127.3434,3340.9177 125.4144,3339.5947 C123.4854,3338.2727 122.9934,3335.6367 124.3164,3333.7067 C125.6394,3331.7777 128.2754,3331.2857 130.2044,3332.6087"
                      id="Fill-279"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M372.9876,3431.7971 C369.1986,3431.2961 366.5336,3427.8191 367.0336,3424.0301 C367.5346,3420.2411 371.0116,3417.5761 374.8006,3418.0771 C378.5896,3418.5771 381.2556,3422.0551 380.7546,3425.8431 C380.2536,3429.6321 376.7766,3432.2981 372.9876,3431.7971"
                      id="Fill-281"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M517.8198,3451.7637 C514.7228,3454.0037 510.3968,3453.3087 508.1578,3450.2117 C505.9178,3447.1147 506.6128,3442.7887 509.7098,3440.5497 C512.8068,3438.3097 517.1328,3439.0047 519.3718,3442.1017 C521.6118,3445.1977 520.9168,3449.5237 517.8198,3451.7637"
                      id="Fill-283"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M416.3966,3631.3226 C418.4556,3634.5416 417.5156,3638.8216 414.2956,3640.8806 C411.0766,3642.9396 406.7976,3641.9996 404.7376,3638.7796 C402.6786,3635.5606 403.6196,3631.2816 406.8386,3629.2216 C410.0576,3627.1626 414.3376,3628.1036 416.3966,3631.3226"
                      id="Fill-285"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M525.0654,3632.7691 C526.3254,3634.7391 525.7504,3637.3591 523.7794,3638.6191 C521.8094,3639.8791 519.1904,3639.3041 517.9294,3637.3331 C516.6694,3635.3631 517.2454,3632.7441 519.2154,3631.4831 C521.1854,3630.2231 523.8054,3630.7991 525.0654,3632.7691"
                      id="Fill-287"
                      fill="#EDEDED"
                    ></path>
                    <path
                      d="M1022.259,122.117 C1022.259,125.939 1019.161,129.037 1015.339,129.037 C1011.517,129.037 1008.419,125.939 1008.419,122.117 C1008.419,118.295 1011.517,115.197 1015.339,115.197 C1019.161,115.197 1022.259,118.295 1022.259,122.117"
                      id="Fill-309"
                      fill="#EDEDED"
                    ></path>

                    <polyline
                      id="Stroke-299"
                      stroke="#EDEDED"
                      points="1379.1523 293.2225 1300.3763 366.9165 1179.2473 532.9395 1404.1923 371.5265 1473.4583 293.2225 1550.8223 490.8645 1300.3763 366.9165 1172.3273 334.1635 1179.2473 532.9395"
                    ></polyline>
                    <polyline
                      id="Stroke-329"
                      stroke="#EDEDED"
                      points="680.9062 1273.3328 885.6002 1307.7148 804.5252 1248.9748 1266.8352 1303.4788 1123.3032 1355.6608 1039.8022 1323.0158 885.6002 1307.7148 885.6002 1237.8188 804.5252 1248.9748 589.1432 1248.9748"
                    ></polyline>
                    <polyline
                      id="Stroke-325"
                      stroke="#EDEDED"
                      points="268.3713 704.4378 204.1853 874.4668 385.6293 705.5298 469.1303 738.1738 598.1623 711.3588 681.8933 1092.9838 677.6583 1162.6148"
                    ></polyline>
                    <polyline
                      id="Stroke-333"
                      stroke="#EDEDED"
                      points="1123.3032 1355.6605 1319.2392 1587.5975 1403.2742 1532.3585 1367.2062 1332.0055 1226.7302 1483.5725"
                    ></polyline>
                    <polyline
                      id="Stroke-335"
                      stroke="#EDEDED"
                      points="1465.1809 1515.526 1472.1029 1644.746 1403.2739 1532.359 1465.1809 1515.526 1580.1869 1413.879 1367.2059 1332.005 1550.8229 1487.809 1472.1029 1644.746"
                    ></polyline>
                    <polyline
                      id="Stroke-337"
                      stroke="#EDEDED"
                      points="1206.5748 1532.3585 1280.6778 1705.0445 1319.2388 1587.5975 1266.8348 1303.4785 1206.5748 1532.3585 1405.7908 1442.7395 1465.1808 1515.5255 1489.0828 1310.8725 1405.7908 1442.7395 1112.1458 1727.8635 1257.4588 1754.3965 1403.2738 1532.3585 1112.1458 1727.8635 1280.6778 1705.0445 1472.1028 1644.7465 1083.8708 1877.0815 1112.1458 1727.8635 933.3258 1812.9945 1083.8708 1877.0815"
                    ></polyline>
                    <polyline
                      id="Stroke-339"
                      stroke="#EDEDED"
                      points="1367.2061 1332.0054 1489.0831 1310.8724 1580.1871 1413.8794"
                    ></polyline>
                    <polyline
                      id="Stroke-343"
                      stroke="#EDEDED"
                      points="1112.1461 1727.8637 892.5211 1906.3417 1083.8701 1877.0817 1257.4581 1754.3957 1472.1021 1644.7467"
                    ></polyline>
                    <polyline
                      id="Stroke-349"
                      stroke="#EDEDED"
                      points="933.3256 1812.9941 721.8676 1963.8491 608.4576 1988.2411 659.6466 1934.8131 721.8676 1963.8491"
                    ></polyline>
                    <polyline
                      id="Stroke-357"
                      stroke="#EDEDED"
                      points="349.7209 2275.8798 384.6699 2132.1138 501.4269 2222.7338 464.0859 2233.7478 448.8609 2067.9358 384.6699 2132.1138 306.1689 2166.8538 306.1689 1917.4978 659.6469 1934.8128"
                    ></polyline>
                    <polyline
                      id="Stroke-359"
                      stroke="#EDEDED"
                      points="396.8442 2355.728 384.6702 2132.114 437.7052 1961.403 448.8612 2067.935 682.2232 2346.316 601.5372 2355.728 448.8612 2067.935"
                    ></polyline>
                    <polyline
                      id="Stroke-367"
                      stroke="#EDEDED"
                      points="268.8155 2067.9354 306.1685 2166.8534 152.6035 2107.3474 211.4185 2209.6644 306.1685 2166.8534 396.8445 2355.7284 464.0855 2233.7474 349.7205 2275.8794 601.5375 2355.7284 501.4265 2222.7334"
                    ></polyline>
                    <polyline
                      id="Stroke-369"
                      stroke="#EDEDED"
                      points="306.1689 2166.8533 148.3679 2315.1483 211.4179 2209.6643 223.1539 2011.6553 437.7049 1961.4033 691.2669 1864.5273 306.1689 1917.4983"
                    ></polyline>
                    <polyline
                      id="Stroke-381"
                      stroke="#EDEDED"
                      points="1524.7028 168.5618 1404.1928 371.5268 1128.4238 179.7168 1090.0238 414.3518 1172.3268 334.1638 1179.2468 532.9398 1022.2588 504.7048 1300.3758 366.9168 1394.9638 117.8818 1200.7068 188.3808 1128.4238 179.7168 1015.3388 122.1168 1132.6588 6.9198 1090.0238 414.3518 1022.2588 504.7048"
                    ></polyline>
                    <polyline
                      id="Stroke-383"
                      stroke="#EDEDED"
                      points="396.8442 2355.728 148.3682 2315.148 349.7212 2275.88"
                    ></polyline>
                    <polyline
                      id="Stroke-385"
                      stroke="#EDEDED"
                      points="601.537 2355.728 501.427 2497.874 682.223 2346.316 396.844 2355.728 501.427 2497.874"
                    ></polyline>
                    <polyline
                      id="Stroke-391"
                      stroke="#EDEDED"
                      points="501.4268 2497.8736 671.0668 2545.9576 809.9268 2657.4526 895.7128 2600.8906 671.0668 2545.9576 792.3888 2537.4866 967.0288 2564.5086 895.7128 2600.8906"
                    ></polyline>
                    <polyline
                      id="Stroke-395"
                      stroke="#EDEDED"
                      points="721.8685 2482.1246 809.9265 2657.4526 792.3885 2537.4866 895.7125 2600.8906 1010.1135 2607.8116 971.2085 2565.1926 1023.9555 2718.4466"
                    ></polyline>
                    <polyline
                      id="Stroke-423"
                      stroke="#EDEDED"
                      points="1367.7236 2837.5176 1166.8756 3075.2286 1206.5796 3055.4856 1060.8206 2935.0886 1006.6836 3087.0216 1381.5666 3183.3816"
                    ></polyline>
                    <polyline
                      id="Stroke-425"
                      stroke="#EDEDED"
                      points="1010.1132 2607.8117 1418.6752 2593.9697 1369.4662 2830.8207"
                    ></polyline>
                    <polyline
                      id="Stroke-433"
                      stroke="#EDEDED"
                      points="887.2946 3179.1462 795.8986 3220.1442 962.4486 3179.1462 684.7886 3204.7522 795.8986 3220.1442 613.0116 3360.7492 784.7416 3113.6122"
                    ></polyline>
                    <polyline
                      id="Stroke-439"
                      stroke="#EDEDED"
                      points="684.7883 3204.7524 373.8943 3424.9374 613.0123 3360.7494 513.7643 3446.1564 414.8033 3487.9504 410.5673 3635.0514 347.3523 3519.9094 373.8943 3424.9374 414.8033 3487.9504"
                    ></polyline>
                    <polyline
                      id="Stroke-443"
                      stroke="#EDEDED"
                      points="613.0119 3360.7491 410.5669 3635.0511 199.4529 3581.4891 347.3519 3519.9091 414.8029 3487.9511 521.4979 3635.0511"
                    ></polyline>
                    <polyline
                      id="Stroke-453"
                      stroke="#EDEDED"
                      points="175.7505 3220.1443 225.7225 3237.1473 373.8945 3424.9373"
                    ></polyline>
                    <polyline
                      id="Stroke-467"
                      stroke="#EDEDED"
                      points="1090.0236 414.3516 1206.3526 385.8336 1550.8226 490.8646 1179.2466 532.9396"
                    ></polyline>
                    <polyline
                      id="Stroke-469"
                      stroke="#EDEDED"
                      points="104.3388 826.5125 6.9198 982.5885 259.7888 1036.9335 534.0358 938.1155 801.8408 627.4055"
                    ></polyline>
                    <polyline
                      id="Stroke-477"
                      stroke="#EDEDED"
                      points="1137.3958 2782.0128 1060.8208 2935.0888 1166.8758 3075.2288"
                    ></polyline>

                    <line
                      x1="556.6708"
                      y1="2056.7793"
                      x2="721.8678"
                      y2="1963.8493"
                      id="Stroke-361"
                      stroke="#EDEDED"
                    ></line>
                    <line
                      x1="211.4181"
                      y1="2209.6646"
                      x2="73.8971"
                      y2="2339.3956"
                      id="Stroke-375"
                      stroke="#EDEDED"
                    ></line>
                    <line
                      x1="204.1852"
                      y1="874.4669"
                      x2="264.0252"
                      y2="958.1749"
                      id="Stroke-377"
                      stroke="#EDEDED"
                    ></line>
                    <line
                      x1="677.6578"
                      y1="1162.6153"
                      x2="492.4228"
                      y2="1099.9033"
                      id="Stroke-379"
                      stroke="#EDEDED"
                    ></line>
                    <line
                      x1="1242.7371"
                      y1="2734.9172"
                      x2="1300.2351"
                      y2="2670.3072"
                      id="Stroke-413"
                      stroke="#EDEDED"
                    ></line>
                    <line
                      x1="127.8096"
                      y1="3336.1019"
                      x2="513.7646"
                      y2="3446.1569"
                      id="Stroke-455"
                      stroke="#EDEDED"
                    ></line>
                    <line
                      x1="1188.0232"
                      y1="2688.9894"
                      x2="1418.6752"
                      y2="2593.9704"
                      id="Stroke-457"
                      stroke="#EDEDED"
                    ></line>
                    <line
                      x1="363.5724"
                      y1="887.8573"
                      x2="396.7864"
                      y2="867.5463"
                      id="Stroke-459"
                      stroke="#EDEDED"
                    ></line>
                    <line
                      x1="1015.3391"
                      y1="122.117"
                      x2="1172.3271"
                      y2="334.164"
                      id="Stroke-461"
                      stroke="#EDEDED"
                    ></line>
                    <line
                      x1="1304.6113"
                      y1="209.9285"
                      x2="1200.7073"
                      y2="188.3805"
                      id="Stroke-463"
                      stroke="#EDEDED"
                    ></line>
                    <line
                      x1="1394.9641"
                      y1="117.8817"
                      x2="1379.1521"
                      y2="82.3057"
                      id="Stroke-465"
                      stroke="#EDEDED"
                    ></line>
                    <line
                      x1="73.3356"
                      y1="735.7542"
                      x2="120.1336"
                      y2="695.2882"
                      id="Stroke-471"
                      stroke="#EDEDED"
                    ></line>
                    <line
                      x1="1550.8226"
                      y1="1487.8087"
                      x2="1405.7906"
                      y2="1442.7387"
                      id="Stroke-473"
                      stroke="#EDEDED"
                    ></line>
                    <line
                      x1="80.868"
                      y1="1965.51"
                      x2="152.604"
                      y2="2107.347"
                      id="Stroke-475"
                      stroke="#EDEDED"
                    ></line>

                    <polygon
                      id="Stroke-289"
                      stroke="#EDEDED"
                      points="1379.1523 82.3053 1132.6583 6.9203 1200.7073 188.3813"
                    ></polygon>
                    <polygon
                      id="Stroke-291"
                      stroke="#EDEDED"
                      points="1304.6113 209.9285 1524.7023 168.5615 1379.1523 82.3055"
                    ></polygon>
                    <polygon
                      id="Stroke-293"
                      stroke="#EDEDED"
                      points="1172.327 334.1637 1200.707 188.3807 1404.193 371.5267 1379.152 293.2227 1206.353 385.8337"
                    ></polygon>
                    <polygon
                      id="Stroke-295"
                      stroke="#EDEDED"
                      points="1451.7169 225.7403 1304.6109 209.9283 1379.1519 293.2223 1473.4579 293.2223"
                    ></polygon>
                    <polygon
                      id="Stroke-297"
                      stroke="#EDEDED"
                      points="1394.9641 117.8817 1451.7171 221.5057 1132.6591 6.9197 1206.3531 385.8337 1304.6111 209.9287"
                    ></polygon>
                    <polygon
                      id="Stroke-301"
                      stroke="#EDEDED"
                      points="1022.259 504.7044 932.189 584.3824 589.419 580.1464 598.163 711.3584 661.13 627.4054 847.201 544.0944"
                    ></polygon>
                    <polygon
                      id="Stroke-303"
                      stroke="#EDEDED"
                      points="777.7288 563.1153 730.0608 655.4673 847.2008 544.0943"
                    ></polygon>
                    <polygon
                      id="Stroke-305"
                      stroke="#EDEDED"
                      points="801.8405 627.4058 932.1895 584.3828 847.2005 544.0948 1022.2595 504.7048"
                    ></polygon>
                    <polygon
                      id="Stroke-307"
                      stroke="#EDEDED"
                      points="661.1298 627.4058 730.0608 655.4678 801.8408 627.4058 589.4188 580.1468 469.1298 738.1738 534.0358 938.1158 598.1628 711.3588 385.6298 705.5298 396.7858 867.5458"
                    ></polygon>
                    <polygon
                      id="Stroke-311"
                      stroke="#EDEDED"
                      points="932.1891 584.3826 1179.2471 532.9396 1090.0231 414.3516"
                    ></polygon>
                    <polygon
                      id="Stroke-313"
                      stroke="#EDEDED"
                      points="492.4225 1099.9034 396.7865 867.5464 120.1335 695.2884 166.0225 933.8804"
                    ></polygon>
                    <polygon
                      id="Stroke-315"
                      stroke="#EDEDED"
                      points="264.0249 958.1754 469.1299 738.1744 267.5459 631.6414 172.9429 803.9984 259.7889 1036.9334"
                    ></polygon>
                    <polygon
                      id="Stroke-317"
                      stroke="#EDEDED"
                      points="104.3388 826.5125 204.1848 874.4665 363.5728 887.8575 268.3708 704.4375 120.1338 695.2885 6.9198 982.5885 268.3708 704.4375 681.8938 1092.9835 259.7888 1036.9335 73.3358 735.7545"
                    ></polygon>
                    <polygon
                      id="Stroke-319"
                      stroke="#EDEDED"
                      points="492.4225 1099.9034 730.0605 655.4674 534.0355 938.1154 267.5465 631.6414"
                    ></polygon>
                    <polygon
                      id="Stroke-321"
                      stroke="#EDEDED"
                      points="589.1435 1248.9749 264.0245 958.1749 363.5725 887.8569"
                    ></polygon>
                    <polygon
                      id="Stroke-323"
                      stroke="#EDEDED"
                      points="729.1606 1213.2208 534.0356 938.1158 680.9066 1273.3328"
                    ></polygon>
                    <polygon
                      id="Stroke-327"
                      stroke="#EDEDED"
                      points="729.1606 1213.2208 988.3766 1213.2208 1039.8026 1323.0158"
                    ></polygon>
                    <polygon
                      id="Stroke-331"
                      stroke="#EDEDED"
                      points="1403.2738 1532.3585 1266.8348 1303.4785 1367.2058 1332.0055 1226.7308 1483.5725 885.6008 1307.7145 1123.3028 1355.6605 1206.5748 1532.3585 1226.7308 1483.5725"
                    ></polygon>
                    <polygon
                      id="Stroke-341"
                      stroke="#EDEDED"
                      points="849.0319 1829.439 933.3259 1812.994 892.5209 1906.342"
                    ></polygon>
                    <polygon
                      id="Stroke-345"
                      stroke="#EDEDED"
                      points="721.868 1963.8496 849.032 1829.4386 691.267 1864.5276"
                    ></polygon>
                    <polygon
                      id="Stroke-347"
                      stroke="#EDEDED"
                      points="892.5211 1906.3419 691.2671 1864.5279 659.6471 1934.8129"
                    ></polygon>
                    <polygon
                      id="Stroke-351"
                      stroke="#EDEDED"
                      points="448.8612 2067.9354 608.4572 1988.2414 306.1692 1917.4984"
                    ></polygon>
                    <polygon
                      id="Stroke-353"
                      stroke="#EDEDED"
                      points="437.7048 1961.403 608.4578 1988.241 556.6708 2056.779"
                    ></polygon>
                    <polygon
                      id="Stroke-355"
                      stroke="#EDEDED"
                      points="501.4268 2222.7334 556.6708 2056.7794 268.8158 2067.9354"
                    ></polygon>
                    <polygon
                      id="Stroke-363"
                      stroke="#EDEDED"
                      points="223.1542 2011.6556 80.8682 1965.5096 306.1692 1917.4976"
                    ></polygon>
                    <polygon
                      id="Stroke-365"
                      stroke="#EDEDED"
                      points="268.8155 2067.9354 223.1545 2011.6554 152.6035 2107.3474"
                    ></polygon>
                    <polygon
                      id="Stroke-371"
                      stroke="#EDEDED"
                      points="349.7209 2275.8798 211.4179 2209.6648 396.8439 2355.7278"
                    ></polygon>
                    <polygon
                      id="Stroke-373"
                      stroke="#EDEDED"
                      points="73.8973 2339.3952 152.6043 2107.3472 148.3683 2315.1482"
                    ></polygon>
                    <polygon
                      id="Stroke-387"
                      stroke="#EDEDED"
                      points="721.8685 2482.1246 682.2225 2346.3156 671.0665 2545.9576"
                    ></polygon>
                    <polygon
                      id="Stroke-389"
                      stroke="#EDEDED"
                      points="501.4268 2497.8736 721.8688 2482.1246 792.3888 2537.4866"
                    ></polygon>
                    <polygon
                      id="Stroke-393"
                      stroke="#EDEDED"
                      points="1010.1132 2607.8117 809.9262 2657.4527 1023.9562 2718.4467"
                    ></polygon>
                    <polygon
                      id="Stroke-397"
                      stroke="#EDEDED"
                      points="1188.0232 2688.9894 1023.9562 2718.4464 1137.3962 2782.0124 1242.7372 2734.9174"
                    ></polygon>
                    <polygon
                      id="Stroke-399"
                      stroke="#EDEDED"
                      points="1010.1132 2607.8117 1137.3962 2782.0127 1188.0232 2688.9897"
                    ></polygon>
                    <polygon
                      id="Stroke-401"
                      stroke="#EDEDED"
                      points="1300.2352 2670.3067 1010.1132 2607.8117 1268.6652 2870.6747"
                    ></polygon>
                    <polygon
                      id="Stroke-403"
                      stroke="#EDEDED"
                      points="1418.6757 2593.9699 1300.2357 2670.3069 1466.6017 2693.2249"
                    ></polygon>
                    <polygon
                      id="Stroke-405"
                      stroke="#EDEDED"
                      points="1434.0698 2777.7766 1367.7238 2837.5176 1300.2348 2670.3066"
                    ></polygon>
                    <polygon
                      id="Stroke-407"
                      stroke="#EDEDED"
                      points="1275.0095 2909.0864 1268.6655 2870.6754 1367.7235 2837.5174"
                    ></polygon>
                    <polygon
                      id="Stroke-409"
                      stroke="#EDEDED"
                      points="1434.0698 2777.7766 1466.6018 2693.2246 1618.4408 2725.3686"
                    ></polygon>
                    <polygon
                      id="Stroke-411"
                      stroke="#EDEDED"
                      points="1542.1879 2877.9463 1466.6019 2693.2253 1242.7369 2734.9173 1060.8209 2935.0883 1275.0099 2909.0863"
                    ></polygon>
                    <polygon
                      id="Stroke-415"
                      stroke="#EDEDED"
                      points="1489.7715 2988.6948 1434.0695 2777.7768 1367.7235 3024.7368"
                    ></polygon>
                    <polygon
                      id="Stroke-417"
                      stroke="#EDEDED"
                      points="1542.1879 2877.9463 1489.7719 2988.6943 1367.7239 2837.5173 1618.4409 2725.3683"
                    ></polygon>
                    <polygon
                      id="Stroke-419"
                      stroke="#EDEDED"
                      points="1381.5667 3183.3816 1367.7237 3024.7366 1206.5797 3055.4856"
                    ></polygon>
                    <polygon
                      id="Stroke-421"
                      stroke="#EDEDED"
                      points="1275.0095 2909.0864 1381.5665 3183.3814 1166.8755 3075.2294"
                    ></polygon>
                    <polygon
                      id="Stroke-427"
                      stroke="#EDEDED"
                      points="1166.876 3075.229 1006.684 3087.022 962.448 3179.146"
                    ></polygon>
                    <polygon
                      id="Stroke-429"
                      stroke="#EDEDED"
                      points="887.2946 3179.1462 962.4486 3179.1462 784.7416 3113.6122"
                    ></polygon>
                    <polygon
                      id="Stroke-431"
                      stroke="#EDEDED"
                      points="1006.6837 3087.0216 784.7417 3113.6116 795.8987 3220.1436"
                    ></polygon>
                    <polygon
                      id="Stroke-435"
                      stroke="#EDEDED"
                      points="684.7883 3204.7524 613.0123 3360.7494 408.0073 3265.6834"
                    ></polygon>
                    <polygon
                      id="Stroke-437"
                      stroke="#EDEDED"
                      points="408.0074 3265.6838 513.7644 3446.1568 373.8944 3424.9368"
                    ></polygon>
                    <polygon
                      id="Stroke-441"
                      stroke="#EDEDED"
                      points="521.4976 3635.0513 513.7646 3446.1563 410.5676 3635.0513"
                    ></polygon>
                    <polygon
                      id="Stroke-445"
                      stroke="#EDEDED"
                      points="408.0074 3265.6838 127.8094 3336.1018 188.2954 3416.4428"
                    ></polygon>
                    <polygon
                      id="Stroke-447"
                      stroke="#EDEDED"
                      points="373.8942 3424.9369 199.4522 3581.4889 164.5932 3468.6779"
                    ></polygon>
                    <polygon
                      id="Stroke-449"
                      stroke="#EDEDED"
                      points="188.2958 3416.4427 164.5938 3468.6777 175.7508 3220.1447"
                    ></polygon>
                    <polygon
                      id="Stroke-451"
                      stroke="#EDEDED"
                      points="225.7227 3237.1474 408.0077 3265.6834 199.4527 3581.4894"
                    ></polygon>
                  </g>
                </g>
              </g>

              <!-- BACKGROUND LINES START -->

              <!-- BLUE LINE START -->

              <path
                id="path"
                d="M1276 318 1121.5 504 757.933594 537.1748 288 851 416.5 1028 416.5 1028 754 1236 1211.2043 1359.89633 1346 1543 1230 1682 984.449219 1877.0815 632 1908 252 2117 499 2275.8797 762 2598 1199 2739.2432 1349 2929 1095 3149 771.332031 3165.49219 536 3269 382 3474"
                stroke="#0F3663"
                fill="none"
              />

              <circle
                r="2"
                id="dot"
                cy="-5"
                cx="0"
                fill="#0F3663"
                fill-opacity=".96"
                fill-rule="evenodd"
                stroke="#0F3663"
                stroke-width=".55"
              />

              <circle
                id="Oval1"
                fill="#0F3663"
                cx="1276"
                cy="318"
                r="7"
              ></circle>
              <circle
                id="Oval2"
                fill="#0F3663"
                cx="1121.5"
                cy="504"
                r="4"
              ></circle>
              <circle
                id="Oval3"
                fill="#0F3663"
                cx="758.5"
                cy="538"
                r="4"
              ></circle>
              <circle
                id="Oval4"
                fill="#0F3663"
                cx="288"
                cy="851"
                r="7"
              ></circle>
              <circle
                id="Oval5"
                fill="#0F3663"
                cx="416.5"
                cy="1028"
                r="4"
              ></circle>
              <circle
                id="Oval6"
                fill="#0F3663"
                cx="754"
                cy="1236"
                r="4"
              ></circle>
              <circle
                id="Oval7"
                fill="#0F3663"
                cx="1211.5"
                cy="1361"
                r="4"
              ></circle>
              <circle
                id="Oval8"
                fill="#0F3663"
                cx="1346"
                cy="1543"
                r="7"
              ></circle>
              <circle
                id="Oval9"
                fill="#0F3663"
                cx="1230"
                cy="1682"
                r="4"
              ></circle>
              <circle
                id="Oval10"
                fill="#0F3663"
                cx="984"
                cy="1877"
                r="4"
              ></circle>
              <circle
                id="Oval11"
                fill="#0F3663"
                cx="632"
                cy="1908"
                r="4"
              ></circle>
              <circle
                id="Oval12"
                fill="#0F3663"
                cx="252"
                cy="2117"
                r="7"
              ></circle>
              <circle
                id="Oval13"
                fill="#0F3663"
                cx="499"
                cy="2275"
                r="4"
              ></circle>
              <circle
                id="Oval14"
                fill="#0F3663"
                cx="762"
                cy="2598"
                r="4"
              ></circle>
              <circle
                id="Oval15"
                fill="#0F3663"
                cx="1199"
                cy="2738"
                r="4"
              ></circle>
              <circle
                id="Oval16"
                fill="#0F3663"
                cx="1349"
                cy="2929"
                r="7"
              ></circle>
              <circle
                id="Oval17"
                fill="#0F3663"
                cx="1095"
                cy="3149"
                r="4"
              ></circle>
              <circle
                id="Oval18"
                fill="#0F3663"
                cx="772"
                cy="3166"
                r="4"
              ></circle>
              <circle
                id="Oval19"
                fill="#0F3663"
                cx="536"
                cy="3269"
                r="4"
              ></circle>
              <circle
                id="Oval20"
                fill="#0F3663"
                cx="382"
                cy="3474"
                r="7"
              ></circle>

              <!-- BLUE LINE END -->
            </svg>
          </div>
        </div>
      </div>
    </section>

    <section class="main-content grey">
      <div class="wrapper">
        <div class="inside">
          <div class="description">
            <p class="main-title">Lottery is in our DNA</p>
            <h2>Lottery innovators for nearly 50 years</h2>
            <p>
              Some people think digital solutions build human connections. We
              think humans shape great digital solutions. We focus on research,
              UX, player data and our lottery experience that began in 1974 to
              create solutions players want and need. Things like mobile cashing
              and AdaptEP™. Things that help lotteries win.
            </p>
            <a href="https://www.linkedin.com/showcase/marcus-thomas-lottery-solutions" target="_blank" class="btn_orange">FOLLOW US ON LINKEDIN</a>
          </div>
        </div>
      </div>
    </section>

    <section class="content-section blue-two-col" v-in-viewport="">
      <div class="container-fluid">
        <div class="inside row">
          <div class="description">
            <p class="main-title">Our Experience</p>
            <h2>We surround ourselves with winners</h2>
            <p>
              Over the last 25+ years, we’ve built our digital team to drive
              gaming engagement and revenue, and to extract value from the data
              generated by that engagement. This approach has created great
              engagement for us, too. We work with lotteries, their vendors and
              their agencies throughout the U.S. – always focused on the value
              exchange and on delivering measurable results.
            </p>
          </div>
          <div class="list-container">
            <ul class="list">
              <li class="slide"><span>Loyalty and Rewards</span></li>
              <li class="slide"><span>Mobile Apps</span></li>
              <li class="slide"><span>Websites and Platforms</span></li>
              <li class="slide"><span>AdaptEP™</span></li>
              <li class="slide"><span>Mobile Cashing</span></li>
              <li class="slide"><span>Hosting and Dev Ops</span></li>
              <li class="slide"><span>Systems Integration</span></li>
              <li class="slide">
                <span>Retailer Acquisition and Management</span>
              </li>
              <li class="slide"><span>CRM and Marketing Automation</span></li>
              <li class="slide">
                <span>Marketing and Systems Consulting</span>
              </li>
              <li class="slide">
                <span>Analytics and Performance Optimization</span>
              </li>
              <li class="slide"><span>Experience Design and Testing</span></li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- Logos  -->
    <section class="logos-container" v-in-viewport="">
      <div class="row">
        <div class="logos">
          <div class="slide">
            <img src="/dist/OH_Lottery.png" />
          </div>
          <div class="slide">
            <img src="/dist/Mega_Millions.png" />
          </div>
          <div class="slide">
            <img src="/dist/virgina_lottery.png" />
          </div>
          <div class="slide">
            <img src="/dist/nhlottery.png" />
          </div>
          <div class="slide">
            <img src="/dist/intralot.png" />
          </div>
        </div>
      </div>
    </section>

    <!-- In The News  -->
    <section class="in-news">
      <div class="container-fluid">
        <div class="inside row">
          <div class="description">
            <h2>In the News</h2>
            <div class="news-container">
              <a
                href="https://www.linkedin.com/feed/update/urn:li:activity:6971421895611101184"
                target="_blank"
                class="news"
              >
                <img
                  src="../assets/img/lottery/news_01.png"
                  alt="Some details from Netflix's ad-supported offering"
                  class="o-fit"
                />
                <h3>Some details from Netflix's ad-supported offering</h3>
              </a>
              <a href="https://www.linkedin.com/feed/update/urn:li:activity:6986078747175108608" target="_blank" class="news">
                <img
                  src="../assets/img/lottery/news_02.jpg"
                  alt="Push my button: not all UX testing is on screen"
                  class="o-fit"
                />
                <h3>Push my button: not all UX testing is on screen</h3>
              </a>
              <a
                href="https://lafleurs.com/conferences/"
                target="_blank"
                class="news"
              >
                <img
                  src="../assets/img/lottery/news_03.png"
                  alt="Lot's to learn in the steel city"
                  class="o-fit"
                />
                <h3>Lot's to learn in the steel city</h3>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Contact Form  -->
    <contact :contactFormInfo="contactFormInfo"></contact>
    <div class="clearfix"></div>
    
    <!-- Footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import seoModule from "../mixins/seoModule.js";
import contactForm from "../components/contact-form-lottery.vue";
import Footer from "../layout/footer-component.vue";
import slider from "../components/slider-cases.vue";

require("../assets/img/about.png");
require("../assets/img/arrow-down_ACACAC.svg");
require("../assets/img/lottery/brands/intralot.png");
require("../assets/img/lottery/brands/nhlottery.png");
require("../assets/img/lottery/brands/Mega_Millions.png");
require("../assets/img/lottery/brands/OH_Lottery.png");
require("../assets/img/lottery/brands/virgina_lottery.png");

export default {
  name: "Lottery",
  data() {
    return {
      // pageLottery: [],
      // modularContent: [],
      contactFormInfo: [],
      sliders: [],
    };
  },
  created: function () {
    //document.body.classList.add("healtcare");
    this.loadLotteryData();

    setTimeout(function () {
      function getWidth() {
        return Math.max(
          document.body.scrollWidth,
          document.documentElement.scrollWidth,
          document.body.offsetWidth,
          document.documentElement.offsetWidth,
          document.documentElement.clientWidth
        );
      }

      function resizeSVG() {
        var browser = getWidth();
        var m = (browser - 1623) / 2;
        if (browser < 1623) {
          $(".svg-bg").css("margin-left", m + "px");
        } else {
          $(".svg-bg").css("margin-left", "auto");
        }
      }

      window.addEventListener("resize", () => {
        resizeSVG();
      });
      resizeSVG();
    }, 1500);
  },
  methods: {
    loadLotteryData() {
      this.$http.get("/src/data_jsons/lottery_data.json").then((response) => {
        let formInfo = response.body.items[0].elements.contact_form.value[0];
        this.pageLottery = response.body.items[0];
        this.modularContent = response.body.modular_content;
        this.contactFormInfo = response.body.modular_content[formInfo].elements;

        let sliders = this.pageLottery.elements.cases.value;
        if (sliders.length) {
          for (var slider in sliders) {
            if (this.modularContent.hasOwnProperty(sliders[slider])) {
              this.sliders.push(this.modularContent[sliders[slider]].elements);
            }
          }
        }
        
        // Show footer after loading data
        setTimeout(function () {
          $("#footer").show();
        }, 500);
      });
    }
  },
  mounted: function () {
    $(document).ready(function () {
      var scrollPercentage = 0;
      // var percentDone;

      ScrollTrigger.create({
        trigger: ".tech-cases",
        start: "top 25%",
        end: "bottom 75%",
        // markers: true,
        onUpdate: (self) => {
          // console.log("progress:", self.progress.toFixed(3), "direction:", self.direction, "velocity", self.getVelocity());
          scrollPercentage = self.progress.toFixed(10);
          drawLine($("#bx_a"), document.getElementById("path"));
          positionTheDot();
          // console.log("progress:", scrollPercentage)
        },
      });

      // init the line length
      drawLine($("#bx_a"), document.getElementById("path"));
      positionTheDot();

      function checkColisions(currentY) {
        if (currentY) {
          for (var i = 2; i <= 20; i++) {
            var tmpName = "Oval" + i;
            checkPosition(currentY, tmpName);
          }
        }
      }

      function checkPosition(currentY, refElement) {
        var refOval = document.getElementById(refElement);
        var refOvalCY = refOval.cy.animVal.value;
        var refOvalBottom = refOvalCY; // + (refOvalR / 2);

        if (currentY >= refOvalBottom) {
          refOval.style.display = "block";
        } else {
          refOval.style.display = "none";
        }
      }

      //draw the line
      function drawLine(container, line) {
        var pathLength = line.getTotalLength(),
          maxScrollTop = $(document).height() - $(window).height(),
          percentDone = $(window).scrollTop() / maxScrollTop,
          length = scrollPercentage * pathLength;
        line.style.strokeDasharray = [length, pathLength].join(" ");
      }

      function positionTheDot() {
        // let refContainer = document.getElementById("container");

        // What percentage down the page are we?
        // var scrollPercentage = (document.documentElement.scrollTop + document.body.scrollTop) / (document.documentElement.scrollHeight - document.documentElement.clientHeight);

        // Get path length
        var path = document.getElementById("path");
        var pathLen = path.getTotalLength();

        // Get the position of a point at <scrollPercentage> along the path.
        var pt = path.getPointAtLength(scrollPercentage * pathLen);

        var scrollY = window.scrollY || window.pageYOffset;
        var maxScrollY =
          document.documentElement.scrollHeight - window.innerHeight;
        var path = document.getElementById("path");

        // Calculate distance along the path the car should be for the current scroll amount
        var pathLen = path.getTotalLength();
        var dist = (pathLen * scrollY) / maxScrollY;
        var pos = path.getPointAtLength(dist);

        // Calculate position a little ahead of the car (or behind if we are at the end), so we can calculate car angle
        if (dist + 1 <= pathLen) {
          var posAhead = path.getPointAtLength(dist + 1);
          var angle = Math.atan2(posAhead.y - pos.y, posAhead.x - pos.x);
        } else {
          var posBehind = path.getPointAtLength(dist - 1);
          var angle = Math.atan2(pos.y - posBehind.y, pos.x - posBehind.x);
        }

        checkColisions(pt.y);

        // Position the red dot at this point
        var dot = document.getElementById("dot");
        dot.setAttribute(
          "transform",
          "translate(" + pt.x + "," + (pt.y + 5) + ")"
        );
      }

      function animationFn() {
        // SETUP
        var animTime = 0.5;
        var halfAnimTime = animTime / 2;
        var crossAnimTime = ">-" + animTime / 2;
        var frameDelayTime = ">2";
        var smallDelayTime = ">.5";

        var defaultEaseOut = Power3.easeOut;
        var defaultEaseIn = Power3.easeIn;
        var defaultEaseInOut = Power3.easeInOut;
        var defaultEaseBackOut = Back.easeOut.config(1);
        var defaultEaseBackIn = Back.easeIn.config(0.5);

        var offsetDown = 100;
        var offsetUp = -100;

        var line2Height = line2.clientHeight / 2;
        var line2HeightOut = line2Height * -1;
        var line3Height = line3.clientHeight / 2;
        var line3HeightOut = line3Height * -1;
        var line4Height = line4.clientHeight / 2;

        // console.log("line2Height: " + line2Height);

        // ANIMATION
        setTimeout(function () {
          $('.headline-wysiwyg').css({'opacity':'1'});
        var tl = gsap.timeline();
        
        tl

          // FRAME 1

          .staggerFrom(
            [phrase1, phrase2, phrase3],
            animTime,
            {
              y: offsetDown,
              autoAlpha: 0,
              ease: defaultEaseOut,
              force3D: false,
            },
            halfAnimTime,
            "0"
          )
          .staggerTo(
            [phrase1, phrase2, phrase3],
            animTime / 3,
            { y: 10, ease: defaultEaseInOut, force3D: false },
            0.1,
            crossAnimTime
          )
          .staggerTo(
            [phrase1, phrase2, phrase3],
            animTime,
            {
              y: offsetUp,
              autoAlpha: 0,
              ease: defaultEaseBackIn,
              force3D: false,
            },
            0.15,
            frameDelayTime
          )

          .from(
            line2,
            animTime,
            {
              y: line2Height,
              rotationX: 90,
              autoAlpha: 0,
              overwrite: "all",
              ease: defaultEaseOut,
              force3D: false,
            },
            smallDelayTime
          )
          .to(
            line2,
            animTime,
            {
              y: line2HeightOut,
              rotationX: -90,
              autoAlpha: 0,
              overwrite: "all",
              ease: defaultEaseOut,
              force3D: false,
            },
            frameDelayTime
          )

          .from(
            line3,
            animTime,
            {
              y: line3Height,
              rotationX: 90,
              autoAlpha: 0,
              overwrite: "all",
              ease: defaultEaseOut,
              force3D: false,
            },
            smallDelayTime
          )
          .to(
            line3,
            animTime,
            {
              y: line3HeightOut,
              rotationX: -90,
              autoAlpha: 0,
              overwrite: "all",
              ease: defaultEaseOut,
              force3D: false,
            },
            frameDelayTime
          )

          .from(
            line4,
            animTime,
            {
              y: line4Height,
              rotationX: 90,
              autoAlpha: 0,
              overwrite: "all",
              ease: defaultEaseOut,
              force3D: false,
            },
            smallDelayTime
          )
          .from(
            statement,
            animTime,
            { autoAlpha: 0, ease: defaultEaseOut, force3D: false },
            ">1"
          );
        }, 1500)
        // console.log(tl.totalDuration());
      }
      animationFn(); 
      
    });

    $(".logos-container .logos").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      draggable: false,
      // centerMode: true,
      autoplay: true,
      speed: 3000,
      autoplaySpeed: 500,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    });

    $(".blue-two-col .list").slick({
      slidesToShow: 8,
      // slidesToScroll: 2,
      centerMode: true,
      // centerPadding: '150px',
      autoplay: true,
      speed: 1000,
      autoplaySpeed: 300,
      vertical: true,
      dots: false,
      draggable: false,
      arrows: false,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: "unslick",
        },
      ],
    });
  },
  computed: {
    version: function () {
      return "v2";
    },
  },
  components: {
    // hero: hero,
    Footer: Footer,
    contact: contactForm,
    // slider: slider,
  },
  mixins: [seoModule],
};
</script>



// WEBPACK FOOTER //
// Lottery.vue?5e9b3014